import { cn } from '../lib/utils';

/**
 * Skeleton — subtle shimmering placeholder. Uses accent stripes rather than
 * a heavy pulse to stay on-brand.
 */
export function Skeleton({ className }) {
  return (
    <div
      aria-hidden
      className={cn(
        'relative overflow-hidden bg-muted',
        'before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_1.6s_infinite]',
        'before:bg-gradient-to-r before:from-transparent before:via-foreground/5 before:to-transparent',
        className
      )}
    />
  );
}

export function ProductCardSkeleton() {
  return (
    <div className="animate-pulse" data-testid="product-card-skeleton">
      <Skeleton className="aspect-[3/4] w-full" />
      <div className="mt-5 flex items-start justify-between gap-4">
        <div className="flex-1 space-y-2">
          <Skeleton className="h-3 w-3/4" />
          <Skeleton className="h-2 w-1/3" />
        </div>
        <Skeleton className="h-3 w-12" />
      </div>
    </div>
  );
}

export function ArticleCardSkeleton() {
  return (
    <div className="grid md:grid-cols-3 gap-6">
      <Skeleton className="aspect-[4/3] md:col-span-1" />
      <div className="md:col-span-2 space-y-3">
        <Skeleton className="h-3 w-1/3" />
        <Skeleton className="h-6 w-3/4" />
        <Skeleton className="h-3 w-full" />
      </div>
    </div>
  );
}

// Keyframes injected via tailwind config would be cleaner; inline @keyframes
// here to keep skeleton self-contained.
if (typeof document !== 'undefined' && !document.getElementById('skeleton-kf')) {
  const style = document.createElement('style');
  style.id = 'skeleton-kf';
  style.textContent = '@keyframes shimmer { 100% { transform: translateX(100%); } }';
  document.head.appendChild(style);
}
